<template>
  <div class="switcher">
    <div
      v-for="(item, index) in options"
      :key="index"
      :class="['switcher-item', isCurrent(index) ? 'active' : '']"
    >
      <button
        class="switcher-button"
        @click="$emit('input', item)"
        :style="{ color: isCurrent(index) ? (item.hasOwnProperty('color') ? item.color : '#1D89BF') : 'black' }"
      >
        {{ item[fieldName] }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'custom-switcher',
  props: {
    value: {
      type: [Object, null],
    },
    options: {
      type: Array,
      required: true,
    },
    fieldName: {
      type: String,
      default: () => 'Name',
    },
  },
  methods: {
    isCurrent(index) {
      return this.options[index][this.fieldName] === this.value[this.fieldName];
    },
  },
});
</script>

<style lang="scss" scoped>
.switcher {
    @include flex (row, flex-start, stretch);
    flex-basis: 100%;
    min-height: 40px;
    background-color: #F3F3F3;

    &-item {
        position: relative;
        @include flex (row, space-between, stretch);
        padding: 0px 8px;
        white-space: nowrap;

        &::before {
            content: "";
            position: absolute;
            width: 0;
            bottom: 0;
            left: 3px;
            height: 1px;
            background: $color-gray_dark;
        }

        &.active {
            &:before {
                width: 96%;
                background: $color-blue;
                transition: 0.4s ease-in-out;
            }

            .date-button {
                color: $color-blue;
            }
        }
    }

    &-button {
        font-size: 16px;
        font-weight: 300;
        color: $color-title;
        transition: color 0.3s $transition;
        cursor: pointer;

        &:hover {
            color: $color-blue;
        }

    }
}

</style>
